import React from 'react';
import '../../styles/people.css';
import { choose } from '../../utils/platform';
import { useGuestCard } from './useGuestCard';
import GuestCardDesktop from './GuestCard.desktop';
import GuestCardMobile from './GuestCard.mobile';

const GuestCardView = choose(GuestCardDesktop, GuestCardMobile);

// /g/<uuid> — the page the QR code on an invitation label opens. Public: the
// person holding the card has it in their hand already.
export default function GuestCard() {
  const vm = useGuestCard();
  return <GuestCardView vm={vm} />;
}
